module.exports = __webpack_public_path__ + "static/media/ic_sec_cons_durable.71992818.svg";